/* istanbul ignore file */
import OwnerInput from 'domain/sales/shared/input/OwnerInput';
import { useAuthorization } from 'framework/authorization';
import { CHANGE_OWNER } from 'domain/sales/salesService';
import { READ_FULL_OPPORTUNITIES_LIST } from 'domain/sales/opportunity/opportunityService';

const OpportunityOwnerInput = (props: { source: string }) => {
  const { isGranted } = useAuthorization();

  return (
    <OwnerInput
      isUserCanChange={isGranted(CHANGE_OWNER) || isGranted(READ_FULL_OPPORTUNITIES_LIST)}
      label="Opportunity owner"
      dropdownPlaceholder="Choose opportunity owner"
      {...props}
    />
  );
};

export default OpportunityOwnerInput;
